import React, { Suspense, useContext } from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { AppContextProvider } from "./context/AppContext";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/custom.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Loader from "./components/Loader";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Auth/Home";
import SignIn from "./pages/Auth/SignIn";
import Error from "./pages/Error";

import { Challenge, Register } from "./pages";
import DashboardIndex from "./pages/Auth/Dashboard";
import ForgotPasswordIndex from "./pages/Auth/ForgotPassword";
import OtpIndex from "./pages/Auth/OTPVerification";
import SuccessfullyIndex from "./pages/Auth/Successfully";
import SubscriptionIndex from "./pages/subscription plan/Index";
import Profile from "./pages/Auth/Profile";
import WhatsappConfiIndex from "./pages/whatsapp configuration/Index";
import ListQuestionsIndex from "./pages/List of Questions/Index";
import ChatIndex from "./pages/chat/Index";
import ProfileIndex from "./pages/profile";
import SubscriptionInner from "./pages/subscription plan/SubscriptionIndex";
import SubscriptionPayment from "./pages/subscription plan/Index"
import ChangePassIndex from "./pages/Change Password/Index";
import Card from "./pages/subscription plan/Card"
import ScheduleMessage from "./pages/ScheduleMessage";
import ContactAccess from "./pages/ContactAccess";
import Template from "./pages/Template";
import DashboardWhatsappIndex from "./pages/whatsapp configuration/DashboardWhatsapp";

window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {
  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={true} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/forgot-password" element={<ForgotPasswordIndex />} />
      <Route path="/sign-up" element={<Register />} />
      <Route path="/otp-verification" element={<OtpIndex />} />
      <Route path="/successfully-verified" element={<SuccessfullyIndex />} />

      {/* <Route path="/subscription" element={<SubscriptionIndex />} />
      <Route
        path="/subscription-plan"
        element={<SubscriptionInner />}
      />
      <Route
        path="/subscription-payment"
        element={<SubscriptionPayment />}
      />
        <Route
        path="/payment/credit-card"
        element={<Card />}
      /> */}

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        {/* Auth Routes */}
        <Route exact path="/" element={<Home />} />
        <Route exact path="/dashboard" element={<DashboardIndex />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route
          exact
          path="/whatsapp-configuration/:id"
          element={<WhatsappConfiIndex />}
        />
        <Route
          exact
          path="/whatsapp-configuration-dashboard"
          element={<DashboardWhatsappIndex />}
        />
        <Route
          exact
          path="/list-of-questions"
          element={<ListQuestionsIndex />}
        />
        <Route exact path="/chat" element={<ChatIndex />} />
        <Route exact path="/my-profile" element={<ProfileIndex />} />


        <Route
          exact
          path="/subscription-plan"
          element={<SubscriptionInner />}
        />
        <Route
          exact
          path="/subscription-payment"
          element={<SubscriptionPayment />}
        />
        <Route
          exact
          path="/payment/credit-card"
          element={<Card />}
        />
        <Route
          exact
          path="/schedule-message"
          element={<ScheduleMessage />}
        />
        <Route
          exact
          path="/contact-access"
          element={<ContactAccess />}
        />
        <Route
          exact
          path="/template"
          element={<Template />}
        />


        <Route exact path="/change-password" element={<ChangePassIndex />} />
        {/* customer */}
      </Route>

      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
